import { NgClass } from '@angular/common'
import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'lib-timeline-step',
  imports: [MatIconModule, NgClass],
  templateUrl: './timeline-step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './timeline-step.component.scss',
})
export class TimelineStepComponent {
  readonly title = input.required<string>()
  readonly status = input<'done' | 'in-progress' | 'error'>('done')

  readonly showProgress = signal(true)
}
